import * as Tickets from "repository/TicketRepository";

export const createMapReportTicket = async (mapTitle, projectId, message) => {
    return Tickets.createTicket(
        "technical",
        "PRIORITY_LOW",
        `Map Issue Report: ${mapTitle}`,
        message,
        projectId,
        null
    )
}

export const createProjectReportTicket = async (projectId, code) => {
    return Tickets.createTicket(
        "technical",
        "PRIORITY_LOW",
        `Project could not be opened: ${projectId}`,
        `Editor open failed with ${code}`,
        projectId,
        null
    )
}
